import { SvgIcon, SvgIconProps } from '@mui/material'
import { NovaColours, useAppContext } from '@novafuturltd/core'

export const GameIcon = (props: SvgIconProps) => {
  const { mode } = useAppContext()
  const defaultFill = NovaColours.N040[mode]

  return (
    <SvgIcon {...props} viewBox="0 0 76 76">
      <path
        d="M46.4643 26.6146C46.4643 26.6146 52.9283 34.457 54.797 37.456C56.4755 40.149 55.5209 43.8492 52.8915 45.737C50.4714 47.4742 47.1852 47.2748 45.1954 45.2594L45.7116 49.5026C45.7648 49.9384 45.3806 50.3015 44.9482 50.2239L39.6194 49.2675C39.187 49.1899 38.953 48.7163 39.1544 48.3258L41.1234 44.5082C38.5473 45.7168 35.3829 44.7499 33.7208 42.2638C31.9216 39.5727 32.3277 35.7733 34.8445 33.8408C37.6489 31.6875 46.4643 26.6146 46.4643 26.6146Z"
        fill={defaultFill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.8254 6.57837L66.1628 12.5614C68.4472 12.9714 69.9714 15.1623 69.5614 17.4467L60.7795 66.3798C60.3695 68.6642 58.1785 70.1884 55.8941 69.7784L45.2072 67.8604L14.7884 68.5287C14.5018 68.5344 14.2241 68.5131 13.9514 68.4642C12.0227 68.118 10.5356 66.4478 10.4882 64.4158L9.4015 14.7111C9.34846 12.3926 11.1959 10.464 13.5144 10.411L27.9188 10.0956L27.9401 9.97699C28.3501 7.69258 30.541 6.16838 32.8254 6.57837ZM56.6091 65.7945C56.7 65.8108 56.7839 65.7525 56.7995 65.6655L65.5815 16.7324C65.5971 16.6455 65.5394 16.5576 65.4485 16.5413L32.1112 10.5583C32.0242 10.5427 31.9396 10.605 31.924 10.692L23.142 59.625C23.1264 59.712 23.1848 59.7959 23.2718 59.8115L56.6091 65.7945ZM13.4435 14.6247L14.5349 64.3261C14.5351 64.4159 14.6122 64.4869 14.7019 64.4867L25.1297 64.2571L22.5568 63.7954C20.2724 63.3854 18.7482 61.1945 19.1582 58.91L27.1897 14.1585L13.6041 14.4577C13.5143 14.4579 13.4433 14.5349 13.4435 14.6247Z"
        fill={defaultFill}
      />
    </SvgIcon>
  )
}

export default GameIcon
